import { FEEDBACK_FORM_TYPE } from 'constants/ProjectConstants';

import { endpoints } from '../constants/endpoints';
import { sendRequest } from './sendRequest';

export function shareNewFeedbackApi({ body, nudgeId = null, receiverIds = [], is_new_panel = false }) {
  const url = endpoints.performanceReview.continuousFeedback.share;
  const requestObject = {
    url,
    method: 'POST',
    credentials: 'include',
    body,
    queryParams: {
      is_new_panel,
    },
  };
  if (Array.isArray(receiverIds) && receiverIds.length > 0) {
    requestObject.queryParams = {
      ...requestObject.queryParams,
      receiver_ids: receiverIds.join(','),
    };
  }
  if (nudgeId) {
    requestObject.queryParams = {
      ...requestObject.queryParams,
      nudge_id: nudgeId,
    };
  }
  return sendRequest(requestObject);
}

export function getFeedbackDetailsByIdApi({ feedbackId }) {
  const url = endpoints.performanceReview.continuousFeedback.get(feedbackId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
}

export function requestNewFeedbackApi({ body, providerIds = [], is_new_panel = false }) {
  const url = endpoints.performanceReview.continuousFeedback.request;

  const requestObj = {
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      is_new_panel,
    },
    body,
  };

  if (Array.isArray(providerIds) && providerIds.length > 0) {
    requestObj.queryParams = {
      ...requestObj.queryParams,
      provider_ids: providerIds.join(','),
    };
  }

  return sendRequest(requestObj);
}

export function shareRequestedFeedbackApi({ body, feedbackId, is_new_panel }) {
  const url = endpoints.performanceReview.continuousFeedback.shareRequested(feedbackId);
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      is_new_panel,
    },
    body,
  });
}

export function archiveFeedbackApi({ feedbackId }) {
  const url = endpoints.performanceReview.continuousFeedback.archive(feedbackId);
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
  });
}

export function acceptFeedbackApi({ feedbackId }) {
  const url = endpoints.performanceReview.continuousFeedback.accept(feedbackId);
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
  });
}

export function declineFeedbackApi({ feedbackId }) {
  const url = endpoints.performanceReview.continuousFeedback.decline(feedbackId);
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
  });
}

export function getLandingPageFeedbackStatsApi() {
  const url = endpoints.performanceReview.continuousFeedback.stats;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
}

export function getAllSharedFeedbackListApi() {
  const url = endpoints.performanceReview.continuousFeedback.all;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      feedback_type: FEEDBACK_FORM_TYPE.PROVIDED,
    },
  });
}

export function getAllRequestedFeedbackListApi() {
  const url = endpoints.performanceReview.continuousFeedback.all;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      feedback_type: FEEDBACK_FORM_TYPE.REQUESTED,
    },
  });
}

export function getAllSharedFeedbackListV1Api({ limit, offset, feedbackType }) {
  const url = endpoints.performanceReview.continuousFeedback.allSharedFeedbacksV1;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      limit,
      offset,
      feedback_type: feedbackType,
    },
  });
}

export function getAllReceivedFeedbackListV1Api({ limit, offset, feedbackType }) {
  const url = endpoints.performanceReview.continuousFeedback.allReceivedFeedbacksV1;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      limit,
      offset,
      feedback_type: feedbackType,
    },
  });
}

export function getFeedbackTableApi({ limit, offset, feedbackStatus, employeeId }) {
  const url = endpoints.performanceReview.continuousFeedback.feedbackTable;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      limit,
      offset,
      feedback_status: feedbackStatus,
      ...(employeeId ? { emp_id: employeeId } : {}),
    },
  });
}

export function getReceivedFeedbackTableApi({ limit, offset, employeeId }) {
  const url = endpoints.performanceReview.continuousFeedback.receivedFeedbackTable(employeeId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      limit,
      offset,
    },
  });
}

export function getRequestedFeedbackApi({ feedbackId }) {
  const url = endpoints.performanceReview.continuousFeedback.requestedFeedBack(feedbackId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
}

export function getSharedOrReceivedFeedbackApi({ postId }) {
  const url = endpoints.performanceReview.continuousFeedback.sharedOrReceivedFeedback(postId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
}

export function getDeleteReceivedFeedbackApi({ feedbackId }) {
  const url = endpoints.performanceReview.continuousFeedback.deleteFeedback(feedbackId);
  return sendRequest({
    url,
    method: 'DELETE',
    credentials: 'include',
  });
}
